module.exports = __webpack_public_path__ + "img/dd9.33c29b18.jpg";